import { APP_DEFAULT_LANGUAGE } from '../constants/common';

export const getLanguage = () => {
  try {
    const storedLanguage = localStorage.getItem('lang');
    return storedLanguage || APP_DEFAULT_LANGUAGE; // Default to 'en' if no language is set
  } catch (error) {
    console.error('Error getting language from localStorage', error);
    return 'en'; // Fallback to 'en' on error
  }
};
